module.exports = __webpack_public_path__ + "img/doc-icon.a6e8458c.svg";